import { LucideIcon } from 'lucide-react';
import '../css/Fonts/GoogleFonts.css'
import { useEffect, useRef } from "react";
import ScrollReveal from "scrollreveal";


interface Icard {
    title: string,
    text: string,
    icon: LucideIcon,
    iconBgColor: string,
    iconColor: string,
    data: string,
    position: string
}



export const CardWork = ({title, icon:Icon, text, iconBgColor, iconColor, data, position}:Icard) => {
    
  //Cria a variavel
    const cardCentralWork = useRef<HTMLDivElement | null >(null)

    //Usa o useeffect para renderizar
    useEffect(() => {
      const sr = ScrollReveal()

      //Primeiro nome da variavel, depois current, depois animaçõees
      if(cardCentralWork.current) {
        sr.reveal(cardCentralWork.current, {
          duration: 1500,
        origin: "top",
        distance: "100px",
        easing: 'ease-in-out',
        reset: false
        })
      }

      //para não evitar conflito
      return () => sr.destroy();
    }, [])
  
  
  
  return(
        <div  className="flex p-2 mt-10">

      <article
      ref={cardCentralWork} 
      className='md:flex  md:justify-between'>
          <div className=' group flex flex-col md:w-[30vw] gap-y-4  w-[80vw] md:h-[40vh] bg-black p-4  items-start rounded-md text-start md:hover:border border-red-600'  >

            <span className={`${iconBgColor} p-1 rounded-md group-hover:bg-red-600`}>
              <p className= {`${iconColor} group-hover:text-red-900`}><Icon /></p>
            </span>

              <p className='text-text-2xl font-bold text-white fontTitle group-hover:text-red-600'>{title}</p>
              <p className='text-sm text-gray-400  fontText'>{text}</p>
              
              <div className='flex md:w-[28vw] md:h-[8vh] justify-between md:gap-x-40 gap-x-24'>
                <p className='text-sm text-white font-bold  fontText bg-red-600 rounded-md p-2'>{data}</p>
                <p className='text-sm text-white font-bold  fontText  rounded-md p-2'>{position}</p>
              </div>
              
              
          </div>
      </article>

      
    </div>
    )
}
